// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"xp-z","breadcrumbForward":"yp-z","breadcrumbBack":"zp-z","selected":"Ap-z"};